import { VerifyEntireTypeEnum } from '@/views_v2/verify-credit/types';
import { RouterV2Enum } from '@/router/router-names';
import { HOME_ALL_VERSION_ROUTE_PATHS } from '@/router/utils';
import VueRouter, { Location } from 'vue-router';
import { BioAuthPo } from '@/po/bioAuth';
import { OcrProcessSourceEnum, OcrMsgSourceEnum, OcrOperationSourceEnum } from '../tools/ocr/enum';
import RouterHelper from '../utils/routerHelper';
import URLUtils from '../utils/URLUtils';
import platform from '../utils/platform';
import { VerifySceneEnum } from './types';
import { ubtSendError } from '../utils/ubt';

/**
 * 服务端接口数据分析类型：
 * 0：授信；1：提现；2：我的；3:首页；4：其他
 */
export const getProcessSourceForServer = (
  verifyEntireType: VerifyEntireTypeEnum,
  ocrAfter: boolean,
  ocrAfterLoan: boolean,
): OcrProcessSourceEnum => {
  if (ocrAfter || ocrAfterLoan) {
    return OcrProcessSourceEnum.OCR_AFTER;
  }

  if ([VerifyEntireTypeEnum.CREDIT, VerifyEntireTypeEnum.PRE_CREDIT].includes(verifyEntireType)) {
    return OcrProcessSourceEnum.CREDIT;
  }

  if (verifyEntireType === VerifyEntireTypeEnum.LOAN) {
    return OcrProcessSourceEnum.WITHDRAW;
  }

  if (verifyEntireType === VerifyEntireTypeEnum.ACTIVITY) {
    return OcrProcessSourceEnum.ACTIVITY;
  }

  const query = URLUtils.getQueryMap();
  if (verifyEntireType === VerifyEntireTypeEnum.MODIFY) {
    /** 资料填写页编辑模式-前置页面为“哈啰app首页、小程序首页” */
    if ((platform.isWechatMini && query.fromAppFiananceMPScene === 'home')
      || RouterHelper.isPreviousPage(HOME_ALL_VERSION_ROUTE_PATHS)) {
      return OcrProcessSourceEnum.HOME;
    }

    if (RouterHelper.isPreviousPage(RouterV2Enum.setting)) {
      return OcrProcessSourceEnum.MINE;
    }
  }

  return OcrProcessSourceEnum.OTHER;
};

/**
 * 获取OCR信息带出情况
 * @param identityInfo 身份证信息
 * @returns OcrMsgSourceEnum
 * 1: 二要素带出&OCR照片带出; 2: 二要素带出&OCR照片未带出；3: 不带出任何信息
 */
export const getOcrMsgSource = (identityInfo?: BioAuthPo.Result): OcrMsgSourceEnum => {
  if (!identityInfo) {
    return OcrMsgSourceEnum.NOTHING;
  }
  if (identityInfo.userName
    && identityInfo.idCardNo
    && identityInfo.idCardFrontUrl
    && identityInfo.idCardBackUrl
  ) {
    return OcrMsgSourceEnum.BASIC_AND_PHOTO;
  }
  if (identityInfo.userName && identityInfo.idCardNo) {
    return OcrMsgSourceEnum.ONLY_BASIC;
  }

  return OcrMsgSourceEnum.NOTHING;
};

/**
 * 识别操作来源
 * 常规：ocrGeneralProcess
 * 现金活动：ocrCashReward
 */
export const getOperationSource = (verifyScene: VerifySceneEnum): string => {
  if (verifyScene === VerifySceneEnum.CREDIT_CASH_ACTIVITY) {
    return OcrOperationSourceEnum.CASH_REWARD;
  }
  return OcrOperationSourceEnum.GENERAL;
};

/** 页面跳转 */
export function jumpToPage(this: VueRouter, options: Location, useReplace?: boolean): void {
  try {
    // eslint-disable-next-line no-unused-expressions
    useReplace ? this.replace(options) : this.push(options);
  } catch (err) {
    ubtSendError(err as Error);
  }
}
